export default {
    namespaced: true,
    state: () => ({
        staff : {
            id: null,
            staffId: null,
            staffName : null,
            authorityKbn : null,
        }
    }),
    getters: {
        data(state) {
            return state.staff
        },
        id (state) {
            return state.staff.id
        },
        staffId (state) {
            return state.staff.staffId
        },
        name (state) {
            return state.staff.staffName
        },
        exists (state) {
            return state.staff && state.staff.id !== null && state.staffId !== null && state.staffName !== null
        },
        authorityKbn(state) {
            return state.staff.authorityKbn
        }
    },
    mutations: {
        setStaff(state, payload) {
            state.staff = payload
        },
        clearStaff(state) {
            state.staff = null
        },
    },
    actions: {
        doUpdate({ commit }, staff) {
            commit('setStaff', staff)
        },
        doClear({ commit }) {
            commit('clearStaff')
        },
    },
}
